<script>
import App from "@/pages/layouts/app.vue";
import Form from "@/pages/tester_types/_form.vue";
import storeForm from "@wielink-application/shared/js/mixins/storeForm";

export default {
	components: {Form, App},
	mixins: [storeForm],
	data() {
		return {
			formRoute: route('api.v1.products.tester_types.store'),
			redirectRoute: route('tester_types.index'),
			stayOnPageRedirect: route('tester_types.edit', {productTesterType: '_id_'}),
		}
	},
}
</script>

<template>
	<App title="Meetmiddel toevoegen">
		<form class="mb-4" @submit.prevent="submit" id="tester_type_form">
			<Form ref="form"/>
		</form>

		<template #bottomButtons>
			<FormButtons
				:cancelRoute="redirectRoute"
				@backToOverview="stayOnPage = 0"
				form-id="tester_type_form"
				:loading="loading"
			/>
		</template>
	</App>
</template>